export var InsertPositionPlacement;
(function (InsertPositionPlacement) {
    InsertPositionPlacement["After"] = "after";
    InsertPositionPlacement["Before"] = "before";
    InsertPositionPlacement["End"] = "end";
    InsertPositionPlacement["Start"] = "start";
})(InsertPositionPlacement || (InsertPositionPlacement = {}));
export var AddButtonAction;
(function (AddButtonAction) {
    AddButtonAction["CreateComponent"] = "CreateComponent";
    AddButtonAction["CreateLinkedItem"] = "CreateLinkedItem";
    AddButtonAction["InsertLinkedItem"] = "InsertLinkedItem";
})(AddButtonAction || (AddButtonAction = {}));
export var AddButtonElementType;
(function (AddButtonElementType) {
    AddButtonElementType["LinkedItems"] = "LinkedItems";
    AddButtonElementType["RichText"] = "RichText";
    AddButtonElementType["Unknown"] = "Unknown";
})(AddButtonElementType || (AddButtonElementType = {}));
export var AddButtonPermission;
(function (AddButtonPermission) {
    AddButtonPermission["CreateNew"] = "createNew";
    AddButtonPermission["Edit"] = "edit";
    AddButtonPermission["ViewParent"] = "viewParent";
})(AddButtonPermission || (AddButtonPermission = {}));
export var AddButtonPermissionCheckResult;
(function (AddButtonPermissionCheckResult) {
    AddButtonPermissionCheckResult["ItemNotTranslated"] = "ItemNotTranslated";
    AddButtonPermissionCheckResult["Ok"] = "Ok";
    AddButtonPermissionCheckResult["PermissionMissing"] = "PermissionMissing";
    AddButtonPermissionCheckResult["RteWithForbiddenComponents"] = "RteWithForbiddenComponents";
    AddButtonPermissionCheckResult["Unknown"] = "Unknown";
})(AddButtonPermissionCheckResult || (AddButtonPermissionCheckResult = {}));
export var IFrameMessageType;
(function (IFrameMessageType) {
    IFrameMessageType["ElementClicked"] = "kontent-smart-link:element:clicked";
    IFrameMessageType["ContentItemClicked"] = "kontent-smart-link:content-item:clicked";
    IFrameMessageType["ContentComponentClicked"] = "kontent-smart-link:content-component:clicked";
    IFrameMessageType["Initialized"] = "kontent-smart-link:initialized";
    IFrameMessageType["Status"] = "kontent-smart-link:status";
    IFrameMessageType["AddInitial"] = "kontent-smart-link:add:initial";
    IFrameMessageType["AddAction"] = "kontent-smart-link:add:action";
})(IFrameMessageType || (IFrameMessageType = {}));
export var IFrameResponseType;
(function (IFrameResponseType) {
    IFrameResponseType["AddInitialResponse"] = "kontent-smart-link:add:initial:response";
})(IFrameResponseType || (IFrameResponseType = {}));
//# sourceMappingURL=IFrameCommunicatorTypes.js.map